<template>
  <div class="background-03">
    <br><br>
    <v-layout row wrap justify-center pt-5>
      <v-flex xs12 sm3 md2 text-xs-center>
        <image-app class="animated rotateIn" :imaSize="151" imaSrc="contenido/diapositiva_54" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Tips para garantizar su bienestar financiero'" videoEmbed="ADMINISTRACIONDINERO54Tipsa.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm6 md6 class="animated fadeInUp dura_1">
        <h1 class="davi-curs font-red big-font">Tips</h1>
        <p>
          A continuación le ofrecemos una serie de recomendaciones que serán de mucha utilidad para garantizar su
          <span class="big-font davi-curs">bienestar financiero.</span>
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-54.vue?3714ba32